import React, { useEffect, useState } from 'react'
import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import {
  Button,
  Grid,
  IconButton,
  InputBase,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import {
  archive,
  fetchAttendanceInit,
  remove,
  rollbackItemStatus,
} from '../../AttendanceActions'
import colors from '../../../../assets/colors'
import Icon from '@mdi/react'
import { mdiAutorenew } from '@mdi/js'

const ItemRollbackStatus = ({
  id,
  open,
  handleOpen,
  functionToDispatchOnSucess = () => {},
}) => {
  const dispatch = useDispatch()
  const classes = filterStylesComponents()

  const handleSubmit = async e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    try {
      const resp = await dispatch(rollbackItemStatus(id, values))

      if (resp) {
        functionToDispatchOnSucess()
        handleOpen()
      }
    } catch (e) {
      //
    }
  }

  return (
    <>
      <BaseFilterModal
        open={open}
        title="Retornar Status do Item"
        hiddenHelpButton
        handleOpen={handleOpen}
      >
        <Grid item xs={12} style={{ width: '260px' }}>
          <form
            style={{ width: '100%', height: '100%' }}
            onSubmit={handleSubmit}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography style={{ color: colors.textGray }}>
                  O item retornará ao status antigo
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="message"
                  variant="standard"
                  fullWidth
                  label="Motivo"
                  required
                />
              </Grid>

              <Grid
                item
                xs={12}
                container
                alignItems="center"
                justifyContent="flex-end"
              >
                <Button
                  type="button"
                  onClick={handleOpen}
                  className={classes.btnMoreFilters}
                >
                  Cancelar
                </Button>

                <Button type="submit" className={classes.btnAdd}>
                  Confirmar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </BaseFilterModal>
    </>
  )
}

export default ItemRollbackStatus
